import { render, staticRenderFns } from "./VideoCenter.vue?vue&type=template&id=20864db5&scoped=true"
import script from "./VideoCenter.vue?vue&type=script&lang=js"
export * from "./VideoCenter.vue?vue&type=script&lang=js"
import style0 from "./VideoCenter.vue?vue&type=style&index=0&id=20864db5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20864db5",
  null
  
)

export default component.exports